import React from "react"

const SegmentTitle = ({title}) => (
    <h5>{title.trim().charAt(0).toUpperCase() + title.trim().slice(1).toLowerCase()}</h5>
)

export default SegmentTitle